import { render, staticRenderFns } from "./IprosForm.vue?vue&type=template&id=e001d560"
import script from "./IprosForm.vue?vue&type=script&lang=js"
export * from "./IprosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports